<template>
    <div id="app">
        <router-view></router-view>
        <!-- <Header></Header>
        <div class="main_page">
            <router-view></router-view>
        </div>
        <Footer></Footer> -->
    </div>
</template>

<script>
export default {
    name: 'App',
}
</script>
